import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { strategiesApi } from "src/api";
import { CreateStrategyParams, GridDepthExampleType, StrategyKey, StrategyType } from "src/api/types";
import CButton from "src/component/CButton/CButton";
import CSelect from "src/component/CSelect";
import { useExchangeInfoStore } from "src/store";
import { getPairName } from "src/store/utils";
import * as Yup from "yup";
import styles from "./index.module.scss";
import { useState } from "react";
import { useExchangeAccounts } from "src/hook/useExchangeAccounts";
import React from "react";
import CommonGridDepthForm from "src/component/StrategyForms/CommonGridDepthForm";

export default function GridDepthForm() {
  const store = useExchangeInfoStore();
  const exchanges = useExchangeAccounts();
  const [selectedExchangeAccountId, setSelectedExchangeAccountId] = useState<number | null>(null);

  const exchangeAccountOptions = exchanges.myExchangeAccounts.map((account) => {
    const exchange = store.exchanges.find((exchange) => exchange.id === account.exchangeId);
    const displayName = `${exchange ? exchange.name : "unknown"}: ${account.alias}`;
    return { value: account.id, label: displayName };
  });

  const pairOptions = store.spotPairs.map((pair) => ({
    value: pair.id,
    label: getPairName(pair.base, pair.quote),
  }));

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  return (
    <Formik
      initialValues={{
        strategyName: "",
        pair: "",
        exchangeAccount: "",
        repeatIntervalMsMin: "10000",
        repeatIntervalMsMax: "20000",

        minPrice10: "",
        maxPrice10: "",
        totalAmount10: "",
        layerNum10: "",
      }}
      validationSchema={Yup.object({
        pair: Yup.object().required("Required"),
        exchangeAccount: Yup.object().required("Required"),
      })}
      onSubmit={async (values) => {
        const payload: CreateStrategyParams<GridDepthExampleType> = {
          strategyName: values.strategyName,
          pairId: Number((values.pair as any).value),
          exchangeAccountId: Number((values.exchangeAccount as any).value),
          type: StrategyType.GridDepth,
          preference: {
            minPrice10: Number(values.minPrice10),
            maxPrice10: Number(values.maxPrice10),
            totalAmount10: Number(values.totalAmount10),
            layerNum10: Number(values.layerNum10),
          },
        };
        console.log("payload", payload);

        try {
          const result = await strategiesApi.createStrategyV2(payload);
          window.location.href = `/strategies?tab=${StrategyKey.GridDepth}`;
        } catch (error) {
          alert("创建失败");
        }
      }}
    >
      {({ values, setFieldValue, submitForm }) => {
        return (
          <>
            <Form className={styles.form}>
              <Flex width="calc(100% - 20px)" flexDirection="column" gap={2}>
                <Flex alignItems="center" gap={2} mt={4}>
                  <CSelect
                    classname={styles.select}
                    label={"交易所账户"}
                    placeholder="交易所账户"
                    options={exchangeAccountOptions}
                    onChange={(value) => {
                      setFieldValue("exchangeAccount", value);
                      setSelectedExchangeAccountId((value as any).value);
                    }}
                  />
                </Flex>
                <Flex alignItems="center" gap={2} mt={2}>
                  <CSelect
                    classname={styles.select}
                    label={"交易对"}
                    placeholder="交易对"
                    options={pairOptions}
                    onChange={(value) => {
                      setFieldValue("pair", value);
                    }}
                  />
                </Flex>
                <CommonGridDepthForm styles={styles} />

                <Flex alignItems="center" gap={2} mt={4}>
                  <CButton name="确认创建" onClick={onOpen} />
                </Flex>
              </Flex>
            </Form>
            <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
              <AlertDialogOverlay>
                <AlertDialogContent>
                  <AlertDialogHeader fontSize="lg" fontWeight="bold">
                    确认创建
                  </AlertDialogHeader>

                  <AlertDialogBody>确定立即创建机器人吗？</AlertDialogBody>

                  <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose}>
                      取消
                    </Button>
                    <Button
                      onClick={() => {
                        onClose();
                        submitForm();
                      }}
                      ml={3}
                    >
                      确定
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
          </>
        );
      }}
    </Formik>
  );
}
